import { useEffect, useState } from 'react'
import { parseISO } from 'date-fns'

import { formatElapsedProgressive, leadOverdueThresholdMs } from '@/utils/format'
import { useLeadSla } from '@/hooks/useLeadSla'

/**
 * Живой таймер «время в текущем статусе лида» для карточки канбана.
 * Тикает раз в секунду. Точка отсчёта — lead.status_changed_at.
 * Гамма янтарная (как раздел «Осмотры Avito»): нейтральный, пока в пределах
 * SLA; при превышении порога (см. LEAD_OVERDUE_THRESHOLDS_MS) — янтарный.
 * Показывается для стадий из LEAD_PIPELINE_UI[pipeline].timerStatuses.
 */
export function LeadTimer({
  status,
  statusChangedAt,
}: {
  status: string
  statusChangedAt: string
}) {
  const [, setTick] = useState(0)
  useEffect(() => {
    const id = window.setInterval(() => setTick((x) => x + 1), 1000)
    return () => window.clearInterval(id)
  }, [])

  const thresholds = useLeadSla()
  const ms = Date.now() - parseISO(statusChangedAt).getTime()
  const threshold = leadOverdueThresholdMs(thresholds, status)
  const overdue = threshold != null && ms > threshold
  const mono =
    'shrink-0 font-[family-name:var(--stryzh-font-family-mono)] tracking-[var(--stryzh-letter-spacing-mono)] text-[length:var(--stryzh-font-size-xs)] tabular-nums'

  return (
    <span
      className={
        overdue
          ? `${mono} stryzh-mono-timer--amber`
          : `${mono} text-[color:var(--stryzh-color-text-secondary)]`
      }
    >
      {formatElapsedProgressive(ms)}
    </span>
  )
}
